import { formatMoney } from '@shopify/theme-currency';

const handleize = (text) => {
  if (typeof text === 'undefined') {
    return '';
  }

  let str = text.toLowerCase();

  const toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
  
  // For the old browsers
  for (let i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], "");
  }

  str = str.replace(/\W+/g, "-");

  if (str.charAt(str.length - 1) == "-") {
    str = str.replace(/-+\z/, "");
  }

  if (str.charAt(0) == "-") {
    str = str.replace(/\A-+/, "");
  }

  return str;
};

const truncateString = (str, length, ending = '...') => {
  if (str.length > length) {
    return str.slice(0, length - ending.length) + ending;
  }
  return str;
};

const validateEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return re.test(email);
};

const validatePhoneNumber = (phone) => {
  const re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;

  return re.test(phone);
};

// Private function needed for formatProductPrices()
const formatPrice = (price) => {
  let formatted_price = price;

  if (window.Shopify.country === 'US') {
    formatted_price = formatMoney(price * 100, theme.moneyFormat);
  } else {
    formatted_price = formatMoney(Math.ceil(price * window.Shopify.currency.rate) * 100, theme.moneyFormat);
  }

  return formatted_price;
};

const formatProductPrices = (products, in_cents = false) => {
  const formatted_products = [];

  for (let i = 0; i < products.length; i++) {
    const product = _.clone(products[i]);

    if (typeof product.compare_at_price !== 'undefined' && product.compare_at_price !== null && product.compare_at_price !== '') {
      product.raw_compare_at_price = product.compare_at_price;
      product.compare_at_price = (in_cents) ? formatPrice(product.compare_at_price / 100) : formatPrice(product.compare_at_price);
    } // else {
      // Product list
      // if (typeof product.algolia !== 'undefined' && typeof product.algolia.compare_at_price !== 'undefined' && product.algolia.compare_at_price !== null && product.algolia.compare_at_price !== '') {
      //   product.raw_compare_at_price = product.algolia.compare_at_price * 100;
      //   product.compare_at_price = (in_cents) ? formatPrice(product.algolia.compare_at_price) : formatPrice(product.algolia.compare_at_price);
      // }
    // }

    if (typeof product.price !== 'undefined' && product.price !== null && product.price !== '') {
      product.raw_price = product.price;
      product.price = (in_cents) ? formatPrice(product.price / 100) : formatPrice(product.price);
    } // else {
      // Product list
      // if (typeof product.algolia !== 'undefined' && typeof product.algolia.price !== 'undefined' && product.algolia.price !== null && product.algolia.price !== '') {
      //   product.raw_price = product.algolia.price * 100;
      //   product.price = (in_cents) ? formatPrice(product.algolia.price) : formatPrice(product.algolia.price);
      // }
    // }

    if (typeof product.variants_max_price !== 'undefined' && product.variants_max_price !== null && product.variants_max_price !== '') {
      product.raw_variants_max_price = product.variants_max_price;
      product.variants_max_price = (in_cents) ? formatPrice(product.variants_max_price / 100) : formatPrice(product.variants_max_price);
    } // else {
      // Product list
      // if (typeof product.algolia !== 'undefined' && typeof product.algolia.variants_max_price !== 'undefined' && product.algolia.variants_max_price !== null && product.algolia.variants_max_price !== '') {
      //   product.raw_variants_max_price = product.algolia.variants_max_price * 100;
      //   product.variants_max_price = (in_cents) ? formatPrice(product.algolia.variants_max_price) : formatPrice(product.algolia.variants_max_price);
      // }
    // }

    if (typeof product.variants_min_price !== 'undefined' && product.variants_min_price !== null && product.variants_min_price !== '') {
      product.raw_variants_min_price = product.variants_min_price;
      product.variants_min_price = (in_cents) ? formatPrice(product.variants_min_price / 100) : formatPrice(product.variants_min_price);
    } // else {
      // Product list
      // if (typeof product.algolia !== 'undefined' && typeof product.algolia.variants_min_price !== 'undefined' && product.algolia.variants_min_price !== null && product.algolia.variants_min_price !== '') {
      //   product.raw_variants_min_price = product.algolia.variants_min_price * 100;
      //   product.variants_min_price = (in_cents) ? formatPrice(product.algolia.variants_min_price) : formatPrice(product.algolia.variants_min_price);
      // }
    // }

    if (typeof product.from !== 'undefined' && product.from !== null && product.from !== '') {
      product.raw_from = product.from;
      product.from = (in_cents) ? formatPrice(product.from / 100) : formatPrice(product.from);
    }

    formatted_products.push(product);
  }

  return formatted_products;
};

const getCookie = (cname) => {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return decodeURIComponent(c.substring(name.length, c.length));
    }
  }
};

// Escape HTML to prevent XSS (Cross-Site Scripting) attacks if the values are not properly sanitized.
const escapeHtml = (unsafe) => {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

const debounce = (func, wait) => {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

const currency_symbol = theme.moneyFormat.split('{')[0];

export {
  handleize,
  truncateString,
  validateEmail,
  validatePhoneNumber,
  formatProductPrices,
  currency_symbol,
  getCookie,
  escapeHtml,
  debounce,
};
